document.addEventListener('DOMContentLoaded', function () {
  // Close mobile drawer on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var drawer = document.getElementById('MobileDrawer');
      if (drawer && drawer.hasAttribute('open')) {
        drawer.removeAttribute('open');
      }
    }
  });

  // Product quantity input: prevent values below 1
  document.querySelectorAll('.quantity-selector input[type="number"]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (parseInt(input.value, 10) < 1 || isNaN(parseInt(input.value, 10))) {
        input.value = 1;
      }
    });
  });
});
